// extracted by mini-css-extract-plugin
export default {"container":"webpack-containers-Invitations-AcceptInvitation-module__container","time":"webpack-containers-Invitations-AcceptInvitation-module__time"};